import type { RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { checkoutLoader } from './checkout-loader';

export const checkoutRoutes: RouteObject = {
  loader: checkoutLoader,
  children: [
    {
      path: '/checkout',
      lazy: lazyComponent(
        () => import('@pages/tenant/checkout/checkout-page'),
        'CheckoutPage',
      ),
    },
  ],
};
